/**
 * Utilitários de formatação para o dashboard
 */

export const formatarNumero = (valor) => {
  if (valor === null || valor === undefined) return '0';
  return new Intl.NumberFormat('pt-PT').format(valor);
};

export const formatarDecimal = (valor, casas = 1) => {
  if (valor === null || valor === undefined) return '0';
  return new Intl.NumberFormat('pt-PT', { 
    minimumFractionDigits: casas,
    maximumFractionDigits: casas 
  }).format(valor);
};

export const formatarKm = (valor) => {
  if (valor === null || valor === undefined) return '0 km';
  return `${formatarDecimal(valor)} km`;
};

export const formatarHoras = (minutos) => {
  if (!minutos) return '0h';
  const horas = Math.floor(minutos / 60);
  const mins = minutos % 60;
  return mins > 0 ? `${horas}h ${mins}m` : `${horas}h`;
};

export const formatarPercentagem = (valor) => {
  if (valor === null || valor === undefined) return '0%';
  return `${formatarDecimal(valor)}%`;
};

export const formatarVariacao = (atual, anterior) => {
  if (!anterior || anterior === 0) return atual > 0 ? '+∞' : '0%';
  const variacao = ((atual - anterior) / anterior) * 100;
  const sinal = variacao >= 0 ? '+' : '';
  return `${sinal}${formatarDecimal(variacao)}%`;
};

export const formatarData = (data) => {
  if (!data) return '';
  const d = new Date(data);
  return d.toLocaleDateString('pt-PT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

export const formatarDataCurta = (data) => {
  if (!data) return '';
  const d = new Date(data);
  return d.toLocaleDateString('pt-PT', {
    day: '2-digit',
    month: '2-digit'
  });
};

export const DIAS_SEMANA = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
export const DIAS_SEMANA_COMPLETO = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

// Aliases para compatibilidade
export const formatNumber = formatarNumero;
export const formatDecimal = formatarDecimal;
